import { useAuth } from '~/app/auth/composables/use-auth';
import { SpecialUser } from '~/domain/user/special-user';

/**
 * Feature flags for Empowerment module
 * Centralizes all access control logic for Empowerment features
 */
export function useEmpowermentFeatureFlags() {
	const currentUser = useAuth();

	// Users who have full access to Projects and Shipments (includes Empowerment access)
	const usersWithFullAccess = [
		SpecialUser.AlbertoRigamonti,
		SpecialUser.JulienRipouteau,
		SpecialUser.RomainLanz,
		SpecialUser.PatrickDeBuren,
		SpecialUser.HiteshMalhotra,
		SpecialUser.HugoDerycke,
		SpecialUser.ThomaLiechti,
		SpecialUser.TestDevFederation,
		SpecialUser.TestDevFrFederation,
	] as number[];

	// TODO: Add federation user IDs here when ready to open Applications to specific NFs
	const usersWithApplicationsOnlyAccess: number[] = [];

	const canAccessEmpowerment = computed(() => {
		const userNo = currentUser.no;
		return usersWithFullAccess.includes(userNo) || usersWithApplicationsOnlyAccess.includes(userNo);
	});

	const canViewProjects = computed(() => {
		const userNo = currentUser.no;
		return usersWithFullAccess.includes(userNo);
	});

	const canOnlyAccessApplications = computed(() => {
		const userNo = currentUser.no;
		return usersWithApplicationsOnlyAccess.includes(userNo);
	});

	const canUpdateLanguage = computed(() => {
		return usersWithFullAccess.includes(currentUser.no);
	});

	return {
		canAccessEmpowerment,
		canViewProjects,
		canOnlyAccessApplications,
		canUpdateLanguage,
	};
}
